import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  cover: string;
  rating: number;
  category: string;
  updateInfo: string;
  categoryName: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function VideoCard({
  id,
  title,
  cover,
  rating,
  updateInfo,
  categoryName,
  isHot,
  isNew,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={cover}
          alt={title}
          title={`51视频 - ${title}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          width="800"
          height="450"
        />
        <div className="absolute top-2 left-2 flex gap-1.5">
          {isHot && (
            <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
              热门
            </span>
          )}
          {isNew && (
            <span className="bg-accent-500 text-white text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
              新番
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2 bg-black/65 text-accent-400 text-xs px-2 py-0.5 rounded-md font-semibold whitespace-nowrap">
          {rating.toFixed(1)}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <span className="text-white text-xs whitespace-nowrap">{updateInfo}</span>
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-white/80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{categoryName}</p>
      </div>
    </Link>
  );
}